import React from "react";
import { useLazyGetRequirementListForSectionABySGBPApplicationIdQuery, useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery, } from "../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import RequirementCard from "../utils/RequirementCard";
import SimpleAdditionalFieldsBlock from "../utils/SimpleAdditionalFieldsBlock";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";
import { useSelfEvaluationSection } from "../utils/useSectionEvaluation";

const SectionA = () => {
    const {
        state,
        isLocked,
        sectionRecord,
        fieldList,
        handleFileUpload,
        handleDownload,
        handleDelete,
        handleCaseOfcComment,
        handleFieldChange,
        handleFieldComment,
        handleFieldBlur,
        isFieldInvalid,
        handleApprove,
        handleReject,
        handleClarificationSend,
        approveLoading,
        rejectLoading,
        clarificationLoading,
        approvingReqId,
        rejectingReqId,
        clarifyingReqId,
    } = useSelfEvaluationSection("A", {
        useListQuery: useLazyGetRequirementListForSectionABySGBPApplicationIdQuery,
        useFieldDefsQuery: useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery,
    });

    return (
        <div className="section-card">
            <h3 className="section-title">Section A</h3>
            {sectionRecord.length > 0 ? (
                <div className="evaluation-table-wrapper">
                    {sectionRecord.map((item) => {
                        const reqId = item.sgbpRequirementId;
                        const reqData = state?.sections?.A?.requirements?.[reqId] || { files: [], comment: "" };
                        const matchedFields = fieldList.filter((f) => f.sgbpRequirementId === reqId);

                        return (
                            <RequirementCard
                                key={reqId}
                                item={item}
                                reqId={reqId}
                                isLocked={isLocked}
                                reqData={reqData}
                                statusValue={state.sections?.A?.requirements?.[reqId]?.status}
                                caseOfficerComments={state.sections?.A?.requirements?.[reqId]?.caseOfficerComments}
                                peerReviewerComments={state.sections?.A?.requirements?.[reqId]?.peerReviewerComments}
                                onFileUpload={handleFileUpload}
                                onDownload={handleDownload}
                                onDelete={handleDelete}
                                onCaseOfcCommentChange={handleCaseOfcComment}
                                onClarificationSend={handleClarificationSend}
                                onReject={handleReject}
                                onApprove={handleApprove}
                                clarificationLoading={clarificationLoading && clarifyingReqId === reqId}
                                rejectLoading={rejectLoading && rejectingReqId === reqId}
                                approveLoading={approveLoading && approvingReqId === reqId}
                                isReturnedApplication={state?.sections?.A?.isApplicationReturned}
                            >
                                <SimpleAdditionalFieldsBlock
                                    matchedFields={matchedFields}
                                    sectionFields={state.sections?.A?.fields}
                                    isLocked={isLocked}
                                    isFieldInvalid={isFieldInvalid}
                                    onFieldChange={handleFieldChange}
                                    onFieldComment={handleFieldComment}
                                    onFieldBlur={handleFieldBlur}
                                />
                            </RequirementCard>
                        );
                    })}
                </div>
            ) : (
                <NoRecordFound />
            )}
        </div>
    );
};

export default SectionA;